/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FilteredQuery } from '../../models/filtered-query';
import { GetMeetingsQueryResult } from '../../models/get-meetings-query-result';
import { SortedQuery } from '../../models/sorted-query';

export interface ApiMeetingsGetMeetingsGet$Params {
  PageNumber?: number;
  PageSize?: number;
  Filters?: Array<FilteredQuery>;
  Sorts?: Array<SortedQuery>;
  SearchTerm?: string;
}

export function apiMeetingsGetMeetingsGet(http: HttpClient, rootUrl: string, params?: ApiMeetingsGetMeetingsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMeetingsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiMeetingsGetMeetingsGet.PATH, 'get');
  if (params) {
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
    rb.query('Filters', params.Filters, {});
    rb.query('Sorts', params.Sorts, {});
    rb.query('SearchTerm', params.SearchTerm, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetMeetingsQueryResult>;
    })
  );
}

apiMeetingsGetMeetingsGet.PATH = '/api/Meetings/GetMeetings';
